// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"InputField_inputLabel__1w2sq"};